import { BodyManager } from "./BodyManager.js";
import { Body } from "./Body.js";
import { CheckPoint, Goal, Player, Signboard, SquareMob } from "./UtilBody.js";
import { MyEventListener, EventId, EventManager } from "./EventManager.js";
import { Vector } from "./Vector.js";

export class GameManager extends BodyManager implements MyEventListener {
    checkPoint: CheckPoint | null = null;
    scoreLabel: HTMLDivElement = document.createElement("div");
    arrivedGoal: boolean = false;

    //イベントリスナー
    override eventClassNames: string[] = ["gameLoop", "goal"];

    constructor() {
        super();
        this.keyboardManager.addEvent(["onKeydown"], () => {
            const latestKey = this.keyboardManager.g$latestPressingKey;
            if (["Space", "Enter", "KeyZ"].includes(latestKey)) {
                this.controlBodies.forEach((body) => {
                    if (body instanceof Signboard && this.player?.isTouchingWith(body)) {
                        body.requestRead();
                        return;
                    }
                });
                //デバッグ用
                console.log(this.player?.position.sub(this.position).array);
            }
        });
    }

    /**
     * ゴールしているかどうか
     */
    get g$arrivedGoal(): boolean {
        return this.arrivedGoal;
    }

    /**
     * すでに起動しているチェックポイントが存在するなら、プレイヤーを自害させる
     * ゴールしていた場合はそれをリセットする
     */
    respawn(): void {
        let existsBootedCheckPoint = false;
        this.controlBodies.forEach((body) => {
            if (body instanceof CheckPoint) {
                if (body.booted) {
                    existsBootedCheckPoint = true;
                    return;
                }
            }
        });
        if (!existsBootedCheckPoint) {
            return;
        }
        if (this.player instanceof Player) {
            this.player.die();
            this.player.setPosition(new Vector(0, 0));
            if (this.arrivedGoal) {
                this.arrivedGoal = false;
            }
        }
    }

    /**
     * ループ内容
     */
    protected override loop(): void {
        super.loop();

        const removeList: Body[] = [];
        for (const body of this.controlBodies) {
            //死んだMobの削除
            if (body instanceof SquareMob && body.isDead) {
                removeList.push(body);
            }
            // チェックポイントの更新
            if (body instanceof CheckPoint && body != this.checkPoint && this.player?.isTouchingWith(body)) {
                if (this.checkPoint != body) {
                    for (const body2 of this.controlBodies) {
                        if (body2 instanceof CheckPoint) {
                            body2.s$booted = false;
                        }
                    }
                    this.checkPoint = body;
                    this.checkPoint.s$booted = true;
                }
            }

            //ゴールしているか
            if (body instanceof Goal && this.player?.isTouchingWith(body)) {
                this.goal();
                return;
            }
        }

        //プレイヤーが死んだ場合
        if (this.player != null && removeList.includes(this.player)) {
            const playerIsCameraCenter = this.cameraCenter == this.player;
            this.player = new Player();
            if (this.checkPoint == null) {
                this.player.setPosition(this.position);
            } else {
                this.player.setCenterPosition(this.checkPoint.centerPosition);
            }
            if (playerIsCameraCenter) {
                this.cameraCenter = this.player;
            }
            this.controlBodies.unshift(this.player);
            this.element.appendChild(this.player.element);
        }

        //実際の削除の処理
        removeList.forEach((body) => {
            body.element.remove();
            if (this.cameraCenter == body) {
                this.cameraCenter = null;
            }
            if (this.player == body) {
                this.player = null;
            }
        });

        //削除したBody(残骸)を管理下から外す
        this.controlBodies = this.controlBodies.filter((body) => !removeList.includes(body));
    }

    /**
     * ゴール時の処理
     */
    goal() {
        this.stop();
        this.arrivedGoal = true;
        EventManager.executeListeningEvents("goal", this.eventIds);
    }
}
